import { useLocation } from "react-router-dom";
import { TitleBreadcrumbs } from "~/components/AppHeader";
import EmbedContainer from "~/components/EmbedContainer";
import useAppHeader from "~/contexts/header";
import { useDocumentTitle } from "~/hooks/useDocumentTitle";

const { VITE_DATA_DASHBOARD_URL } = import.meta.env;

const DataOverview = () => {
  const location = useLocation();
  useDocumentTitle("Data Overview");
  useAppHeader({
    title: (
      <TitleBreadcrumbs
        crumbs={[
          { title: "Data Browser", href: "/data-browser" },
          { title: "Overview", href: location.pathname },
        ]}
      />
    ),
  });
  return <EmbedContainer iframeSrc={VITE_DATA_DASHBOARD_URL} />;
};

export default DataOverview;
